















import {Vue, Prop, Component} from 'vue-property-decorator';
import ReservationsConfig from "@/types/ReservationsConfig";

@Component
export default class Reservations extends Vue {

  @Prop({
    type: Object,
    default: {
      number: 0,
    }
  })
  //@ts-ignore
  public reservationsConfig: ReservationsConfig;
}

